import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  imports: [
    CommonModule,
    RouterModule
  ],
  standalone: true,
})
export class CardComponent {
  @Input() title: string = "";
  @Input() description?: string;
  @Input() tipologia?: string | { name: string }[] = "";
  formattedTipologia: string = "";
  @Input() link?: string = "";
  @Input() dataElement?: string = "";

  ngOnInit(): void {
    if (typeof this.tipologia === 'string') {
      // Se tipologia è una stringa singola, lasciala così
      this.formattedTipologia = this.tipologia;
    } else if (Array.isArray(this.tipologia)) {
      // Se tipologia è un array di oggetti, estraiamo la proprietà 'name' da ciascun oggetto
      const namesArray = (this.tipologia as { name: string }[]).filter(tipologia => tipologia.name).map(obj => obj.name);
      this.formattedTipologia = namesArray.join(" / ");
    }
  }

}
